import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { toast } from "react-toastify";
import api from "utils/api";
import CircularProgress from "@mui/material/CircularProgress";

function ViewProductEnq() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [productEnq, setProductEnq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProductEnq();
  }, [id]);

  const fetchProductEnq = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/product-enqs/${id}`);
      if (response.data.success) {
        setProductEnq(response.data.data);
      } else {
        toast.error("Failed to fetch product enquiry");
        navigate("/product");
      }
    } catch (error) {
      console.error("Error fetching product enquiry:", error);
      toast.error(error.response?.data?.message || "Failed to fetch product enquiry");
      navigate("/product");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <ArgonBox
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <CircularProgress color="info" />
        </ArgonBox>
        <Footer />
      </DashboardLayout>
    );
  }

  if (!productEnq) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <ArgonBox py={3}>
          <ArgonTypography variant="h6" color="error">
            Product enquiry not found
          </ArgonTypography>
        </ArgonBox>
        <Footer />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3}>
        <Card>
          <ArgonBox p={3}>
            <ArgonBox mb={3} display="flex" justifyContent="space-between" alignItems="center">
              <ArgonTypography variant="h5" fontWeight="medium">
                Product Enquiry Details
              </ArgonTypography>
              <ArgonButton
                variant="outlined"
                color="secondary"
                size="small"
                onClick={() => navigate("/product")}
              >
                Back to List
              </ArgonButton>
            </ArgonBox>

            <Grid container spacing={3}>
              {/* User Name */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  User Name
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text">
                  {productEnq.userName || "N/A"}
                </ArgonTypography>
              </Grid>

              {/* Product Name */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Product Name
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text">
                  {productEnq.productName || "N/A"}
                </ArgonTypography>
              </Grid>

              {/* Normal Price */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Normal Price
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text">
                  ₹{productEnq.priceNormal || 0}
                </ArgonTypography>
              </Grid>

              {/* Discount Price */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Discount Price
                </ArgonTypography>
                <ArgonTypography variant="body2" color="success">
                  ₹{productEnq.discountPrice || 0}
                </ArgonTypography>
              </Grid>

              {/* Product Image */}
              <Grid item xs={12}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Product Image
                </ArgonTypography>
                <ArgonBox>
                  {productEnq.imageBanner ? (
                    <img
                      src={productEnq.imageBanner}
                      alt={productEnq.productName || "Product"}
                      style={{
                        maxWidth: "300px",
                        maxHeight: "200px",
                        borderRadius: "8px",
                        border: "1px solid #d2d6da",
                      }}
                    />
                  ) : (
                    <ArgonTypography variant="body2" color="text">
                      No image available
                    </ArgonTypography>
                  )}
                </ArgonBox>
              </Grid>

              {/* Created At */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Created At
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text">
                  {productEnq.createdAt ? new Date(productEnq.createdAt).toLocaleString() : "N/A"}
                </ArgonTypography>
              </Grid>

              {/* Updated At */}
              <Grid item xs={12} md={6}>
                <ArgonTypography variant="button" fontWeight="medium" mb={1}>
                  Updated At
                </ArgonTypography>
                <ArgonTypography variant="body2" color="text">
                  {productEnq.updatedAt ? new Date(productEnq.updatedAt).toLocaleString() : "N/A"}
                </ArgonTypography>
              </Grid>
            </Grid>
          </ArgonBox>
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ViewProductEnq;
